export class Keys {
  static readonly PERSONAL_INFO: string = '__personalInfo';
  static readonly SUBSCRIBED: string = '__subscribed';
}
